import { createEffect, createSignal, Show } from "solid-js";
import { calculateDiscountedPrice, formatPrice, getCookie } from "../js/utils";

// RegularDiscountPriceContainer 
const DiscountCouponCallout = (props) => {
  const productInfo = props.productInfo;
  const showApplyButton = () => props.showApplyButton != false && (typeof (Shopify) != 'undefined' && Shopify?.country != undefined && Shopify.country != 'IN');

  async function handleApplyDiscountClick() {
    if (!showApplyButton()) return;

    await window.applyDiscountCode({ title: productInfo.title, pathname: window.location.pathname });
    props.handleApplyDiscountClick();
  }

  return (
    <div class="policyText flex items-center">
      <div
        class="text-sm flex item-center gap-1 text-ink bg-canvas-light cursor-pointer rounded-xl justify-between font-regular w-auto"
        onclick={handleApplyDiscountClick}
      >
        <div class="py-1 px-1" innerHTML={`${props.discountPrice} with code <strong>${props.discountCode}</strong>`} />
        <Show when={showApplyButton()}>
          <button class="text-ink-link font-regular rounded-e-xl bg-canvas-light border-frame border-l-inner  hover:underline px-1 py-1 font-bold shrink-0" >Apply now</button>
        </Show>
      </div>
    </div>
  )
}

export const RegularDiscountPriceContainer = (props) => {
  const productInfo = props.productInfo;
  const showShippingPolicy = props.showShippingPolicy;
  const currentVariant = props.currentVariant; // signal
  const isDiscountApplied = props.isDiscountApplied; // signal
  const currencyConversion = props.currencyConversion;
  const discount = props.discount;
  let couponCodeRef;

  const price = () => {
    isDiscountApplied(); // used as an effect to rerun the price on isDiscountApplied state change

    const { price } = currentVariant();

    return formatPrice(price, currencyConversion);
  }

  const discountPrice = (force = false) => {
    isDiscountApplied(); // used as an effect to rerun the price on isDiscountApplied state change

    const discount_cookie = getCookie('discount_code');

    if (handleize(discount_cookie ?? "") !== handleize(discount.code) && force != true) {
      return null;
    }

    const { price } = currentVariant();

    const newPrice = calculateDiscountedPrice(price, discount.value, 'percentage');
    return formatPrice(newPrice, currencyConversion);
  }


  const compareAtPrice = () => {
    isDiscountApplied(); // used as an effect to rerun the price on isDiscountApplied state change

    const { compareAtPrice } = currentVariant();

    return formatPrice(compareAtPrice, currencyConversion);
  }

  const finalBasePrice = () => {
    if (price() && (discountPrice() == null || (BRAND.discount.messagingType === 'MARKDOWN'))) {
      return price()
    } else {
      return discountPrice()
    }
  }
  const finalCompareAtPrice = () => {
    if ((price() && discountPrice() && BRAND.discount.messagingType != 'MARKDOWN')) {
      return price()
    }
    else {
      return compareAtPrice()
    }
  }

  const finalDiscountPercentage = () => {
    let price = Number(finalBasePrice().replace(/[^0-9\.-]+/g, ""))
    let compareAt = Number(finalCompareAtPrice().replace(/[^0-9\.-]+/g, ""))

    return Math.round((1 - price / compareAt) * 100)
  }

  return (
    <div class="my-2">
      <div
        class="font-mono text-base 2xl:text-lg mt-2 mb-1 ">
        <div class="flex gap-1 items-baseline">
          <span class="base-product-price" >{finalBasePrice()}</span>
          <Show when={(price() && discountPrice()) || BRAND.discount.messagingType === 'MARKDOWN'} >
            <Show when={finalDiscountPercentage() > 1}>
              <span class="line-through opacity-50" >{finalCompareAtPrice()}</span>

              <span class="text-sale-500 text-xs">({finalDiscountPercentage()}% OFF)</span>
            </Show>

          </Show>
        </div>

        <Show when={showShippingPolicy}>
          <span class="text-2xs font-regular px-1">(Inclusive of shipping & taxes)</span>
        </Show>
      </div>

      <Show when={BRAND.discount.messagingType === 'FIRSTBUY' && !isDiscountApplied()}>
        <DiscountCouponCallout
          productInfo={productInfo}
          discountPrice={discountPrice(true)}
          discountCode={discount.code}
          showApplyButton={true}
          handleApplyDiscountClick={() => props.setIsDiscountApplied(true)}
        />
      </Show>

      <div
        ref={couponCodeRef}
        class="hero-coupon-msg appliedDiscountContainer max-w-max block text-xs 2xl:text-sm rounded-lg text-secondary-500 text-left font-regular border border-dashed border-secondary-500 hidden"
        classList={{
          "p-0.5 mt-0.5": props.isModal == true,
          "p-1 my-1": props.isModal != true
        }}
      >
        <p class="confirmationMessage">Coupon code <span class="uppercase code underline"></span> applied</p>
      </div>
    </div>
  )
}


const DiscountCouponCalloutV2 = (props) => {
  const productInfo = props.productInfo;
  const showApplyButton = () => props.showApplyButton != false && (typeof (Shopify) != 'undefined' && Shopify?.country != undefined && Shopify.country != 'IN');

  async function handleApplyDiscountClick() {
    if (!showApplyButton()) return;

    await window.applyDiscountCode({ title: productInfo.title, pathname: window.location.pathname });
    props.handleApplyDiscountClick();
  }

  return (
    <div class="policyText flex items-center">
      <div
        class="item-center flex w-auto cursor-pointer justify-between gap-1 rounded-xl bg-canvas-light font-regular text-2xs font-semibold text-tertiary-300"
        onclick={handleApplyDiscountClick}
      >
        <div class="px-1 py-0.5" innerHTML={`${props.discountPrice} with code <strong>${props.discountCode}</strong>`} />
      </div>
    </div>
  )
}

export const RegularDiscountPriceContainerV2 = (props) => {
  const productInfo = props.productInfo;
  const showShippingPolicy = props.showShippingPolicy;
  const currentVariant = props.currentVariant; // signal
  const currencyConversion = props.currencyConversion;
  const discount = props.discount;
  let couponCodeRef;
  const [appliedDiscountCode, setAppliedDiscountCode] = createSignal('');

  const price = () => {
    appliedDiscountCode(); // used as an effect to rerun the price on isDiscountApplied state change

    const { price } = currentVariant();

    return formatPrice(price, currencyConversion);
  }

  const discountPrice = (force = false) => {
    appliedDiscountCode(); // used as an effect to rerun the price on isDiscountApplied state change

    const discount_cookie = getCookie('discount_code');

    if (handleize(discount_cookie ?? "") !== handleize(discount.code) && force != true) {
      return null;
    }

    const { price } = currentVariant();

    const newPrice = calculateDiscountedPrice(price, discount.value, 'percentage');
    return formatPrice(newPrice, currencyConversion);
  }


  const compareAtPrice = () => {
    appliedDiscountCode(); // used as an effect to rerun the price on isDiscountApplied state change

    const { compareAtPrice } = currentVariant();

    return formatPrice(compareAtPrice, currencyConversion);
  }

  const finalBasePrice = () => {
    if (price() && (discountPrice() == null || (BRAND.discount.messagingType === 'MARKDOWN'))) {
      return price()
    } else {
      return discountPrice()
    }
  }
  const finalCompareAtPrice = () => {
    if ((price() && discountPrice() && BRAND.discount.messagingType != 'MARKDOWN')) {
      return price()
    }
    else {
      return compareAtPrice()
    }
  }

  const finalDiscountPercentage = () => {
    let price = Number(finalBasePrice().replace(/[^0-9\.-]+/g, ""))
    let compareAt = Number(finalCompareAtPrice().replace(/[^0-9\.-]+/g, ""))

    return Math.round((1 - price / compareAt) * 100)
  }

  createEffect(() => {
    console.log("appliedDiscountCode: ", appliedDiscountCode());
    const discountCookie = getCookie('discount_code');
    if (discountCookie && discountCookie?.toLowerCase() != 'remove_discount_codes') {
      setAppliedDiscountCode(discountCookie);
    }
    console.log("discountCookie; ", discountCookie);
  })

  return (
    <div class="flex flex-col text-ink">
      <div class="flex items-center gap-0.5">
        <div class="font-mono text-base 2xl:text-lg">
          {/* <div class="flex items-baseline gap-1">
            <span class="base-product-price text-ink">₹5990.00</span>
          </div> */}
          <div class="flex gap-1 items-baseline">
            <span class="base-product-price text-ink" >{finalBasePrice()}</span>
            <Show when={(price() && discountPrice()) || BRAND.discount.messagingType === 'MARKDOWN'} >
              <Show when={finalDiscountPercentage() > 1}>
                <span class="line-through opacity-50" >{finalCompareAtPrice()}</span>

                <span class="text-sale-500 text-xs">({finalDiscountPercentage()}% OFF)</span>
              </Show>

            </Show>
          </div>
        </div>
        <Show when={BRAND.discount.messagingType === 'FIRSTBUY' && !appliedDiscountCode()}>
          <DiscountCouponCalloutV2
            productInfo={productInfo}
            discountPrice={discountPrice(true)}
            discountCode={discount.code}
            showApplyButton={true}
            handleApplyDiscountClick={() => setAppliedDiscountCode(discount.code)}
          />
        </Show>
      </div>
      <Show when={showShippingPolicy}>
        <div class="text-xs italic">(Inclusive of shipping & taxes)</div>
      </Show>
      <Show when={appliedDiscountCode()}>
        <div
          ref={couponCodeRef}
          class="hero-coupon-msg appliedDiscountContainer my-1 block max-w-max rounded-lg border border-dashed border-secondary-500 p-1 text-left font-regular text-xs text-secondary-500 2xl:text-sm">
          <p class="confirmationMessage">Coupon code <span class="code uppercase underline">{appliedDiscountCode()}</span> applied</p>
        </div>
      </Show>
    </div>
  )
}